module.exports = __webpack_public_path__ + "media/packs/images/flags/SC-d3d288e44120477057890d0cd88adc40.svg";